import { useLocation } from 'react-router-dom';

import { WithSubpages } from '../../subpages';
import { ussdSubpages } from '../../subpages/dictionary';
import { PAGE_TITLE } from '../../consts';

import Editor from './editor';
import { MAIN_PAGE_PATH, EDITOR_PATH } from './paths';

const USSD = () => {
  const { pathname } = useLocation();

  if (pathname === EDITOR_PATH) {
    return <Editor />;
  }

  return <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.USSD} items={ussdSubpages} />;
};

export default USSD;
